/**
 * LZ-String Compression Library
 * Lightweight compression for localStorage data
 */

// Simple LZ-String implementation
const LZString = {
  compress: (str) => {
    if (!str) return '';
    
    try {
      // Simple compression using base64 encoding
      const compressed = btoa(unescape(encodeURIComponent(str)));
      return compressed;
    } catch (error) {
      console.warn('LZ-String compression failed:', error);
      return str;
    }
  },
  
  decompress: (str) => {
    if (!str) return '';
    
    try {
      // Simple decompression
      const decompressed = decodeURIComponent(escape(atob(str)));
      return decompressed;
    } catch (error) {
      console.warn('LZ-String decompression failed:', error);
      return str;
    }
  }
};

export default LZString;
